// extracted by mini-css-extract-plugin
module.exports = {"slide":"OrderPetInfo_slide_OTdBO","slide-reverse":"OrderPetInfo_slide-reverse_mYEWD","OrderPetInfo":"OrderPetInfo_OrderPetInfo_5zyP6"};